/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from "formik";
import * as yup from "yup";
import { toast } from 'react-toastify';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { isEmpty } from "lodash";
import { login, userLoaded } from '../../redux/actions/authActions'
// TODO use check user profiles api
import { checkUserExistence, checkUserProfiles, getUserDetails, verifyOTP } from '../../redux/actions/apiActions'
import { setAuthToken, setRoleName } from "../../utils/setHeaders";
import setGlobalLoader from '../../redux/actions/loaderActions'
import { CircularProgress } from "@mui/material";
import SelectRoleAlert from "./SelectRoleAlert";
import { PROFILES } from "../../utils/constants";

// Get redirect path based on user profile
const getRedirectPath = (profile) => {
  switch (profile) {
    case PROFILES.DEALER:
      return '/cars';
    case PROFILES.ADMIN:
      return '/bookings';
    case PROFILES.ORGANIZATION:
    default:
      return '/students';
  }
};

const validationSchema = yup.object({
  phoneNumber: yup
    .string()
    .trim()
    .required("Phone Number is required.")
    .min(10, "Phone number short than 10 digits.")
    .max(10, "Phone number long than 10 digits."),
  // otp: yup
  //   .string()
  //   .required('Please specify OTP')
  //   .min(6, 'The OTP should must be length of 6 digits.')
  //   .max(6, 'The OTP should must be length of 6 digits.'),
});

const Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [alertOpen, setAlertOpen] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);

  // const isAuthenticated = useSelector(state => state.authReducer.isAuthenticated);
  // const profile = useSelector(state => state.authReducer.profile);

  // useEffect(() => {
  //   if (profile !== null && profile !== undefined && profile !== "" && isAuthenticated === true) {
  //     dispatch(setGlobalLoader(true))
  //     setTimeout(() => {
  //       dispatch(setGlobalLoader(false))
  //       navigate('/students');
  //     }, 1000);
  //   }
  // }, [profile, isAuthenticated])

  const [stepper, setStepper] = useState(1);

  const handleOnSubmit = async (values) => {
    if (isEmpty(values.phoneNumber)) {
      return
    }
    if (!isEmpty(values.phoneNumber) && isEmpty(values.otp)) {


      dispatch(setGlobalLoader(true))

      try {
        await checkUserExistence(values.phoneNumber);
        setStepper(2);
        toast.success('OTP sent successfully');
      dispatch(setGlobalLoader(false))
      } catch (error) {
        dispatch(setGlobalLoader(false))
        toast.error(error.response?.data?.message ?? "User Doesn't Exist. Please signup or contact admin.");
        return
      }
    }
    if (!isEmpty(values.otp) && !isEmpty(values.phoneNumber)) {
      if (values.phoneNumber === "" || values.otp === "") {
        toast.error('Please fill all the required details');
        return
      }

      try {
        if (stepper === 2) {
          dispatch(setGlobalLoader(true));

          try {
            const otpResponse = await verifyOTP({
              phoneNumber: values.phoneNumber,
              otp: values.otp
            });

            const { accessToken, refreshToken } = otpResponse?.data || {};

            if (!accessToken) {
              toast.error('Invalid OTP response');
              dispatch(setGlobalLoader(false));
              return;
            }

            // Store tokens in the same format expected by the reducer
            dispatch(login({ accessToken, refreshToken } ));

            try {
              setAuthToken(accessToken);
              const userProfiles = await checkUserProfiles();
              if (userProfiles?.data?.data?.profiles?.length === 0) {
                toast.error("No roles found. Please contact admin.");
                dispatch(setGlobalLoader(false));
                return
              } else if (userProfiles?.data?.data?.profiles?.length > 1) {
                setRoleOptions(userProfiles?.data?.data?.profiles?.map(role => ({ label: role, value: role })));
                dispatch(setGlobalLoader(false))
                setAlertOpen(true)
                return
              } else {
                const userProfile = userProfiles.data.data.profiles[0];
                setRoleName(userProfile)
                try {
                  const userDetails = await getUserDetails();
                  dispatch(userLoaded(userDetails.data.data))
                  const redirectPath = getRedirectPath(userProfile);
                  setTimeout(() => {
                    dispatch(setGlobalLoader(false))
                    navigate(redirectPath);
                  }, 1000);
                } catch (profileError) {
                  dispatch(setGlobalLoader(false))
                  setAuthToken(null)
                  setRoleName(null)
                  if (profileError.response?.status === 403) {
                    toast.error(profileError.response.data?.msg ?? "Your account is pending approval. Please wait for admin approval.");
                  } else {
                    toast.error(profileError.response?.data?.msg ?? "Some error occurred while fetching account details.");
                  }
                  return
                }
              }
            } catch (error) {
              dispatch(setGlobalLoader(false))
              setAuthToken(null)
              toast.error(error.response?.data?.msg ?? "Some error occurred while fetching account details.");
              return
            }
          } catch (error) {
            console.log(error)
            dispatch(setGlobalLoader(false))
            toast.error(error.response?.data?.message ?? 'OTP verification failed')
            return
          }
        }
        else {
          navigate('/login')
          return
        }
      }
      catch (error) {
        console.log(error)
        navigate('/login')
        return
      }
    }
    navigate('/login')
  };

  // TODO change default navigation after login

  const handleRoleSelection = async (role) => {
    dispatch(setGlobalLoader(true))
    setRoleName(role)
    try {
      const userDetails = await getUserDetails();
      dispatch(userLoaded(userDetails.data.data))
      const redirectPath = getRedirectPath(role);
      setTimeout(() => {
        dispatch(setGlobalLoader(false))
        navigate(redirectPath);
      }, 1000);
    } catch (error) {
      dispatch(setGlobalLoader(false))
      setRoleName(null)
      if (error.response?.status === 403) {
        toast.error(error.response.data?.msg ?? "Your account is pending approval. Please wait for admin approval.");
      } else {
        toast.error(error.response?.data?.msg ?? "Some error occurred while fetching account details.");
      }
    }
  }
  return (
    <Box>
      <Formik
        initialValues={{
          phoneNumber: "",
          otp: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => handleOnSubmit(values)}
      >
        {(formikProps) => {
          const { values, errors, touched, setFieldValue, handleSubmit, isSubmitting } =
            formikProps;
          return (
            <>
              <Box marginBottom={4}>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "medium",
                  }}
                  gutterBottom
                  color={"text.secondary"}
                >
                  Login
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  Welcome back
                </Typography>
                <Typography color="text.secondary">
                  {/* Login to manage your account. */}
                </Typography>
              </Box>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={4}>
                  {stepper === 1 && (
                    <Grid item xs={12}>
                      <Typography
                        variant={"subtitle2"}
                        sx={{ marginBottom: 2 }}
                      >
                        Enter Phone Number
                      </Typography>
                      <TextField
                        label="Phone Number *"
                        variant="outlined"
                        name={"phoneNumber"}
                        fullWidth
                        type="number"
                        value={values.phoneNumber}
                        onChange={(e) =>
                          e.target.value.toString().length > 10 ?
                            setFieldValue("phoneNumber", e.target.value.substring(0, 10))
                            :
                            setFieldValue("phoneNumber", e.target.value)
                        }
                        error={
                          touched.phoneNumber && Boolean(errors.phoneNumber)
                        }
                        helperText={touched.phoneNumber && errors.phoneNumber}
                      />
                    </Grid>
                  )}
                  {stepper === 2 && (
                    <Grid item xs={12}>
                      <Typography
                        variant={"subtitle2"}
                        sx={{ marginBottom: 2 }}
                      >
                        Enter OTP
                      </Typography>
                      <TextField
                        label="OTP *"
                        variant="outlined"
                        name={"otp"}
                        type="number"
                        fullWidth
                        value={values.otp}
                        onChange={(e) =>
                          e.target.value.toString().length > 6
                            ? setFieldValue("otp", e.target.value.substring(0, 6))
                            : setFieldValue("otp", e.target.value)
                        }
                        error={touched.otp && Boolean(errors.otp)}
                        helperText={touched.otp && errors.otp}
                      />
                    </Grid>
                  )}
                  <Grid item container xs={12}>
                    {stepper === 1 && (
                      <Button
                        id='send_otp'
                        size={"large"}
                        variant={"contained"}
                        type={"submit"}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? <CircularProgress /> : "Send OTP"}
                      </Button>
                    )}
                    {stepper === 2 && (
                      <Button
                        size={"large"}
                        variant={"contained"}
                        type={"submit"}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? <CircularProgress /> : "Submit"}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </form>
            </>
          );
        }}
      </Formik>
      <div style={{ padding: 40 }}>
        <SelectRoleAlert
          open={alertOpen}
          options={roleOptions}
          onClose={() => setAlertOpen(false)}
          onConfirm={(role) => handleRoleSelection(role)}
        />
      </div>
    </Box>
  );
};

export default Form;
